module.exports = __webpack_public_path__ + "img/Frame9.7522f275.png";